// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trace-form-item-trace-form-item-5b6ab .trace-form-item-address-0bcac .osui-input{width:260px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trace-form-item": "trace-form-item-trace-form-item-5b6ab",
	"traceFormItem": "trace-form-item-trace-form-item-5b6ab",
	"address": "trace-form-item-address-0bcac"
};
export default ___CSS_LOADER_EXPORT___;
